<div class="w-full h-full">
  <app-sidebar></app-sidebar>
  <div class="relative flex flex-col h-screen md:ml-64 bg-blueGray-100">
    <div class="hidden md:block flex-none">
      <app-admin-navbar></app-admin-navbar>
    </div>
    <!-- <app-header-stats></app-header-stats> -->
    <div class="bg-blueGray-100 grow px-4 md:px-10 justify-items-center mx-auto w-full">
      <router-outlet></router-outlet>
    </div>
    <div class="bg-blueGray-100 flex-none">
      <app-footer-admin></app-footer-admin>
    </div>
  </div>
</div>